import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '加盟商ID',
      prop: 'orgName'
    },
    {
      label: '业务类型',
      prop: 'orderTypeStr'
    },
    {
      label: '业务级别',
      prop: 'busCategoryStr'
    },

    {
      label: '业务名称',
      prop: 'busName'
    },
    {
      label: '业务ID',
      prop: 'busId'
    },
    {
      label: '业务状态',
      prop: 'busStatus'
    },
    {
      label: '开始时间',
      prop: 'busStartTime'
    },
    {
      label: '场地',
      prop: 'placeName'
    },
    {
      label: '姓名',
      prop: 'orderUserName'
    },
    {
      label: '会员账号',
      prop: 'account'
    },
    {
      label: '性别',
      prop: 'gender'
    },
    {
      label: '年龄',
      prop: 'age'
    },
    {
      label: '级别',
      prop: 'level'
    },
    // {
    //   label: '积分',
    //   prop: 'score'
    // },
    {
      label: '会员类型',
      prop: 'mbTypeStr'
    },
    {
      label: '付款金额',
      prop: 'payAmount'
    },
    {
      label: '退款比例',
      prop: 'refundScale'
    },
    {
      label: '退款金额',
      prop: 'refundAmount'
    },
    {
      label: '支付状态',
      prop: 'payStatusStr'
    },
  ]
}
